<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle1"><a id="page_5"><b>Contents</b></a></p><a id="page_5">
</a><p class="toc"><a id="page_5"></a><a href="#/xhtml/05_Introduction"><b>Introduction</b></a></p>
<p class="toci"><i>Samuel Love</i></p>
<p class="toct1"><a href="#/xhtml/06_Part01"><b>OF FAMILY AND LEGENDS</b></a></p>
<p class="toc"><a href="#/xhtml/07_Chapter01"><b>Can Any Good Come Out of Gary? Absolutely Yes!</b></a></p>
<p class="toci"><i>Dena Holland Neal</i></p>
<p class="toc"><a href="#/xhtml/08_Chapter02"><b>Seeing Through the Window of Time</b></a></p>
<p class="toci"><i>Marie Siroky</i></p>
<p class="toc"><span href="#/xhtml/09_Chapter03" title="Link target outside of Sample"><b>Arc of a Diver</b></span></p>
<p class="toci"><i>Tracey Lewis</i></p>
<p class="toc"><span href="#/xhtml/10_Chapter04" title="Link target outside of Sample"><b>John Grisby</b></span></p>
<p class="toci"><i>Kym Mazelle</i></p>
<p class="toc"><span href="#/xhtml/11_Chapter05" title="Link target outside of Sample"><b>Across the Quad</b></span></p>
<p class="toci"><i>Jessica Peterson Rogers</i></p>
<p class="toc"><span href="#/xhtml/12_Chapter06" title="Link target outside of Sample"><b>The Ruins</b></span></p>
<p class="toci"><i>Daniel Summers</i></p>
<p class="toc"><span href="#/xhtml/13_Chapter07" title="Link target outside of Sample"><b>Roy Boy</b></span></p>
<p class="toci"><i>Tim Svetly</i></p>
<p class="toc"><span href="#/xhtml/14_Chapter08" title="Link target outside of Sample"><b>Healthy in the Hood</b></span></p>
<p class="toci"><i>Maya Etienne</i></p>
<p class="toct1"><span href="#/xhtml/15_Part02" title="Link target outside of Sample"><b>STEEL</b></span></p>
<p class="toc"><span href="#/xhtml/16_Chapter09" title="Link target outside of Sample"><b>Gary 1919: An Untold Story of Racial Solidarity</b></span></p>
<p class="toci"><i>Ruth Needleman</i></p>
<p class="toc"><a id="page_6"></a><span href="#/xhtml/17_Chapter10" title="Link target outside of Sample"><b>Untitled</b></span></p>
<p class="toci"><i>Noel Ignatiev</i></p>
<p class="toc"><span href="#/xhtml/18_Chapter11" title="Link target outside of Sample"><b>The Human Toll of the Steel Mill</b></span></p>
<p class="toci"><i>Joseph S. Pete</i></p>
<p class="toc"><span href="#/xhtml/19_Chapter12" title="Link target outside of Sample"><b>Appalachian Apologia</b></span></p>
<p class="toci"><i>Jeff Manes</i></p>
<p class="toct1"><span href="#/xhtml/21_Chapter13" title="Link target outside of Sample"><b>PHOTOGRAPHS</b></span></p>
<p class="toci"><i>Raymar Brunson</i></p>
<p class="toct1"><span href="#/xhtml/22_Part04" title="Link target outside of Sample"><b>GARY POETRY</b></span></p>
<p class="toc"><span href="#/xhtml/23_Chapter14" title="Link target outside of Sample"><b>Black Mecca</b></span></p>
<p class="toci"><i>Alva “Gem of Shaolin” Wilson</i></p>
<p class="toc"><span href="#/xhtml/24_Chapter15" title="Link target outside of Sample"><b>untitled</b></span></p>
<p class="toci"><i>tynlvae taylor</i></p>
<p class="toc"><span href="#/xhtml/25_Chapter16" title="Link target outside of Sample"><b>Privilege of Hope</b></span></p>
<p class="toci"><i>Krissy Mosley</i></p>
<p class="toc"><span href="#/xhtml/26_Chapter17" title="Link target outside of Sample"><b>“When asked to describe Gary in your own words”</b></span></p>
<p class="toci"><i>Dylan Hollingsworth</i></p>
<p class="toc"><span href="#/xhtml/27_Chapter18" title="Link target outside of Sample"><b>#NotMiserableinGary</b></span></p>
<p class="toci"><i>Latrice Young</i></p>
<p class="toc"><span href="#/xhtml/28_Chapter19" title="Link target outside of Sample"><b>delaney</b></span></p>
<p class="toci"><i>Curtis Crisler</i></p>
<p class="toc"><span href="#/xhtml/29_Chapter20" title="Link target outside of Sample"><b>I Am From: Gary, Indiana</b></span></p>
<p class="toci"><i>Lydia Johnson</i></p>
<p class="toc"><a id="page_7"></a><span href="#/xhtml/30_Chapter21" title="Link target outside of Sample"><b>The Return of Ben and Jerry</b></span></p>
<p class="toci"><i>Awanii Nicholson</i></p>
<p class="toct1"><span href="#/xhtml/31_Part05" title="Link target outside of Sample"><b>STORIES OF THE LAND AND ENVIRONMENT</b></span></p>
<p class="toc"><span href="#/xhtml/32_Chapter22" title="Link target outside of Sample"><b>What I Gained by Moving to Gary</b></span></p>
<p class="toci"><i>Terra “Poetry N’ Motion” Cooks</i></p>
<p class="toc"><span href="#/xhtml/33_Chapter23" title="Link target outside of Sample"><b>The Spring at Small Farms</b></span></p>
<p class="toci"><i>Kay Westhues</i></p>
<p class="toc"><span href="#/xhtml/35_Chapter24" title="Link target outside of Sample"><b>Walking the Divided Coast: Gary to Miller Beach</b></span></p>
<p class="toci"><i>Michael McColly</i></p>
<p class="toc"><span href="#/xhtml/36_Chapter25" title="Link target outside of Sample"><b>The Lightning Horse Liquors Couch</b></span></p>
<p class="toci"><i>Deb Weiss</i></p>
<p class="toc"><span href="#/xhtml/37_Chapter26" title="Link target outside of Sample"><b>Lost Keys</b></span></p>
<p class="toci"><i>John L. Harris</i></p>
<p class="toct1"><span href="#/xhtml/38_Part06" title="Link target outside of Sample"><b>AROUND TOWN</b></span></p>
<p class="toc"><span href="#/xhtml/39_Chapter27" title="Link target outside of Sample"><b>A Most Violent Year</b></span></p>
<p class="toci"><i>Scott Cannon, The Khemist</i></p>
<p class="toc"><span href="#/xhtml/40_Chapter28" title="Link target outside of Sample"><b>The G.I.B. Graffiti Block</b></span></p>
<p class="toci"><i>Gerry “Omen74” Guevara</i></p>
<p class="toc"><span href="#/xhtml/41_Chapter29" title="Link target outside of Sample"><b>The Green Grass</b></span></p>
<p class="toci"><i>Lillian Duggan</i></p>
<p class="toc"><span href="#/xhtml/42_Chapter30" title="Link target outside of Sample"><b>The 1972 National Black Political Convention in Gary</b></span></p>
<p class="toci"><i>Nicole Poletika</i></p>
<p class="toc"><a id="page_8"></a><span href="#/xhtml/43_Chapter31" title="Link target outside of Sample"><b>The Journey Home</b></span></p>
<p class="toci"><i>Ryan Flemming</i></p>
<p class="toct1"><span href="#/xhtml/44_Part07" title="Link target outside of Sample"><b>NOW AND NEXT: THE FUTURE OF GARY, INDIANA</b></span></p>
<p class="toc"><span href="#/xhtml/45_Chapter32" title="Link target outside of Sample"><b>Malcolm X Boulevard</b></span></p>
<p class="toci"><i>Kwabena Sakidi Jijaga Rasuli</i></p>
<p class="toc"><span href="#/xhtml/46_Chapter33" title="Link target outside of Sample"><b>LiveArts Studio</b></span></p>
<p class="toci"><i>Desiree’ Simpson</i></p>
<p class="toc"><span href="#/xhtml/47_Chapter34" title="Link target outside of Sample"><b>Nana’s House</b></span></p>
<p class="toci"><i>Devin Hall</i></p>
<p class="toc"><span href="#/xhtml/48_Chapter35" title="Link target outside of Sample"><b>Decay Devils</b></span></p>
<p class="toci"><i>Tyrell Anderson</i></p>
<p class="toct1"><span href="#/xhtml/49_Contributors" title="Link target outside of Sample"><b>END NOTES</b></span></p>
<p class="toc"><span href="#/xhtml/49_Contributors#con" title="Link target outside of Sample"><b>Contributors</b></span></p>
<p class="toct"><span href="#/xhtml/50_Acknowledgement" title="Link target outside of Sample"><b>Acknowledgements</b></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Contents.vue?0f3ecde8